import WithAdditionalValidationState from 'components/WithAdditionalValidation/WithAdditionalValidationState';
import React, { useContext, useEffect } from 'react';
import { ICreateVideoContext, CreateVideoContext } from '../../createVideoState/createVideoContext';
import CreationForm from './components/CreationForm/CreationForm';
import TranslationsForm from './components/TranslationsForm';
import style from './Forms.module.scss';

const Forms: React.FC = () => {
	const { visibleForm } = useContext<ICreateVideoContext>(CreateVideoContext);

	useEffect(() => {
		window.scrollTo(0, 0);
	}, [visibleForm]);

	return (
		<div className={style.container} data-test="Forms">
			<WithAdditionalValidationState>
				<CreationForm isVisible={visibleForm === 'mainForm'} />
				<TranslationsForm isVisible={visibleForm === 'translations'} />
			</WithAdditionalValidationState>
		</div>
	);
};

export default Forms;
